import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { FlangeTypeModel } from '../../../models';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-flange-type2',
    templateUrl: './flange-type2.component.html',
    styleUrls: ['./flange-type2.component.scss'],
    standalone: false,
})
export class FlangeType2Component {
    @Input() form: UntypedFormGroup;
    @Input() defaultFlangeTypeId: string;

    @Input()
    set standardId(value: string) {
        this._standardId = value;
        this.getFlangeTypes();
    }
    get standardId(): string {
        return this._standardId;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
        this.getFlangeTypes();
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
        this.getFlangeTypes();
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }

    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
        this.getFlangeTypes();
    }
    get isCustom(): boolean {
        return this._isCustom;
    }
    destroy$ = new Subject();
    flangeTypeList: FlangeTypeModel[];
    tooltip_position = 'above';
    loading: boolean = false;

    private _standardId: string;
    private _pressureClassId: string;
    private _pipeSizeId: string;
    private _isCustom: boolean;

    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef
    ) {}

    getFlangeTypes(): void {
        if (this.isCustom || (this.standardId && this.pressureClassId && this.pipeSizeId)) {
            this.loading = true;
            this.form.get('flangeType2').setValue('');
            this.iceapi
                .getFlangeTypes(this.standardId, this.pressureClassId, this.pipeSizeId, this.isCustom)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                        this.cd.detectChanges();
                    })
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe((flangeTypes) => {
                    if (flangeTypes.success === true) {
                        this.flangeTypeList = flangeTypes.response;
                        if (!this.form.get('flangeType2').value && this.defaultFlangeTypeId) {
                            this.form.get('flangeType2').setValue(this.defaultFlangeTypeId);
                            this.form.get('flangeType2').updateValueAndValidity();
                        }
                    } else {
                        this.user_utility.errorModelPopup(flangeTypes.message);
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
